var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeacher = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.926 1.555H2.889A.444.444 0 0 0 2.444 2v8c0 .245.2.444.445.444h1.037zm5.185 0H4.815v8.89H9.11c.735 0 1.333-.599 1.333-1.334V2.889c0-.736-.598-1.334-1.333-1.334M7.841 6H6.825a.444.444 0 1 1 0-.89h1.016a.444.444 0 1 1 0 .89m.677-1.778h-2.37a.444.444 0 1 1 0-.89h2.37a.444.444 0 1 1 0 .89"
})));
export default SvgTeacher;